import { axiosInstance } from '../clients/axiosClient';
import { NUTRITIONIST_API_PREFIX, API_V1_PREFIX } from '../utils/constants';
import {
  CreateNutritionistRequestPydantic,
  CreateUserResponse,
  HTTPValidationError,
  ListNutritionistsResponse,
  UpdateNutritionistRequestPydantic,
  UpdateNutritionistResponse,
} from '../types/apiGeneratedTypes';
import { NutritionistLoadStrategy } from '../types/apiGeneratedTypes';

export const getNutritionistsList = async (
  offset: number = 0,
  limit: number = 10,
  loading_strategy: NutritionistLoadStrategy = NutritionistLoadStrategy.AllData,
  sort_by?: string,
  sort_direction?: 'asc' | 'desc'
): Promise<ListNutritionistsResponse> => {
  try {
    const params = new URLSearchParams({
      loading_strategy,
      limit: limit.toString(),
      offset: offset.toString(),
    });

    if (sort_by) {
      params.append('sort_by', sort_by);
    }
    if (sort_direction) {
      params.append('sort_direction', sort_direction);
    }

    const url = `${API_V1_PREFIX}${NUTRITIONIST_API_PREFIX}list?${params.toString()}`;
    console.log('Making nutritionist API call to:', url);
    console.log('Sort parameters:', { sort_by, sort_direction });

    const { data } = await axiosInstance.get(url);

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const createNutritionist = async (
  newNutritionistRequestObject: CreateNutritionistRequestPydantic
): Promise<CreateUserResponse | HTTPValidationError> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${NUTRITIONIST_API_PREFIX}`,
      newNutritionistRequestObject
    );

    return data;
  } catch (error: any) {
    if (error?.response?.data?.detail) {
      return error?.response?.data;
    }
    throw new Error(error);
  }
};
export const updateNutritionist = async (
  nutritionistRequestObject: UpdateNutritionistRequestPydantic
): Promise<UpdateNutritionistResponse | HTTPValidationError> => {
  try {
    const { data } = await axiosInstance.patch(
      `${API_V1_PREFIX}${NUTRITIONIST_API_PREFIX}`,
      nutritionistRequestObject
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const deleteNutritionist = async (
  nutritionistId: string
): Promise<void | HTTPValidationError> => {
  try {
    const { data } = await axiosInstance.delete(
      `${API_V1_PREFIX}${NUTRITIONIST_API_PREFIX}`,
      {
        data: {
          user_id: nutritionistId
        }
      }
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const activateNutritionist = async (nutritionistId: string) => {
  const response = await axiosInstance.patch(
    `${API_V1_PREFIX}${NUTRITIONIST_API_PREFIX}activate`,
    {
      nutritionist_id: nutritionistId
    }
  );
  return response.data;
};

export const deactivateNutritionist = async (nutritionistId: string) => {
  const response = await axiosInstance.patch(
    `${API_V1_PREFIX}${NUTRITIONIST_API_PREFIX}deactivate`,
    {
      nutritionist_id: nutritionistId
    }
  );
  return response.data;
};
